import { FlexWrapper, MenuItemContainer } from "./AppSkeleton.style.ts";
import Skeleton from "react-loading-skeleton";

export const ItemsListSkeleton = () => {
    return (
        <>
            {Array.from({ length: 4 }).map((_, i) => (
                <MenuItemContainer key={i}>
                    <FlexWrapper>
                        <Skeleton width={'100%'} height={100} />
                    </FlexWrapper>
                </MenuItemContainer>
            ))}
        </>
    );
}